import { amplitude, amplitudeEnv } from "@plugins/amplitude"

export const actions = {
  logEvent({}, { name, properties }) {
    if (!name || !amplitudeEnv) return
    amplitude.getInstance().logEvent(name, properties)
  },
}
